module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/feature_five-a2549d670bf2fdec719100ecd652fe35.png";